var moment = require('moment');
var CVTranslator = require("bazinga-translator");

class VisitorInformation {
    constructor(firstnameEl, surnameEl, nationalityEl, surname2El, genderEl, docTypeEl, birthdateEl, docDateEl, docNumEl, emailEl,  phoneNumberEl, addressEl, address2El, cityEl, provinceEl, municipalityEl, postalCodeEl, countryEl, supportNumberEsIdEl, relationshipEl ) {
        this.firstnameEl = firstnameEl;
        this.surnameEl = surnameEl;
        this.nationalityEl = nationalityEl;
        this.holder = $(this.nationalityEl).closest('.card-body');
        this.surname2El = surname2El;
        this.docTypeEl = docTypeEl;
        this.docNumEl = docNumEl;
        this.genderEl = genderEl;
        this.birthdateEl = birthdateEl;
        this.docDateEl = docDateEl;
        this.emailEl = emailEl;
        this.addressEl = addressEl;
        this.address2El = address2El;
        this.cityEl = cityEl;
        this.postalCodeEl = postalCodeEl;
        this.countryEl = countryEl;
        this.municipalityEl = municipalityEl;
        this.provinceEl = provinceEl;
        this.relationshipEl = relationshipEl;
        this.phoneNumberEl = phoneNumberEl;
        this.supportNumberEsIdEl = supportNumberEsIdEl;
        this.age = -1;

        this.setupEvents();
        var todayDate = new Date();
        var that = this;
        this.startTitle = this.holder.parent().parent().find('.card-title a').text();
        $(this.surnameEl).on('keyup', (e) => {
            this.setTitle();
        });
        $(this.surname2El).on('keyup', (e) => {
            this.setTitle();
        });
        $(this.firstnameEl).on('keyup', (e) => {
            this.setTitle();
        });

        this.holder.find('input').on('change', () => {
            this.checkFilled();
        });

        this.checkFilled();
    }

    checkFilled() {
        var allFilled = true;
        var someFilled = 0;
        this.holder.find('input').each((idx, el) => {
            var $el = $(el);
            if (!$el.val() || $el.val() == '') {

                if ($el.attr('id').indexOf('address2') != -1 ) {
                    return;
                }
                if ($el.attr('id').indexOf('supportNumberEsId') != -1)
                    {
                    if ($(this.nationalityEl).val() == 'ES') {
                        $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                        allFilled = false;
                    } else {
                        return;
                    }
                }
                if ($el.attr('id').indexOf('city') != -1) {
                    if ($(this.countryEl).val() != 'ES') {
                        $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                        allFilled = false;
                        return;
                    } else {
                        $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                        someFilled += 1;
                    }
                }
                if ($el.attr('id').indexOf('surname2') != -1) {
                    if ($(this.nationalityEl).val() == 'ES' || $(this.surnameEl).val() == '') {
                        $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                        allFilled = false;
                        return;
                    } else {
                        return;
                    }
                }
                if ($el.attr('id').indexOf('firstName') != -1 || $el.attr('id').indexOf('surname') != -1 ) {
                    if ($(this.firstnameEl).val() == '' || $(this.surnameEl).val() == '') {
                        $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                        allFilled = false;
                        return;
                    } else {
                        $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                        someFilled += 1;
                        return;
                    }
                }
                if ($el.attr('required') == true || $el.attr('required') == 'required') {
                    $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                    allFilled = false;
                } else {
                    $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                    someFilled += 1;
                }
            } else {
                if ($el.attr('id').indexOf('docDate') != -1 || $el.attr('id').indexOf('birthdate') != -1) {
                    if (!this.verifyDate($el.val())) {
                        $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                        allFilled = false;
                        return;
                    } else {
                        $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                        someFilled += 1;
                    }
                } else {
                    $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                    someFilled += 1;
                }
                if ($el.attr('id').indexOf('docNum') != -1) {
                    if(!$(this.docNumEl).val()  || $(this.docNumEl).val() == '') {
                        allFilled = false;
                        return;
                    }
                    if (['D','N'].includes($(this.docTypeEl).val()) && !this.isValidSpanishId($el.val(), $(this.docTypeEl).val() )) {
                        $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                        allFilled = false;
                        return;
                    } else {
                        $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                        someFilled += 1;
                    }
                    
                    if ($(this.docTypeEl).val() == 'P' && $(this.nationalityEl).val() == 'ES' && !this.isValidSpanishPassport($el.val())) {
                        $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                        allFilled = false;
                        return;
                    } else {
                        $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                        someFilled += 1;
                    }
                } else {
                    $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                    someFilled += 1;
                }
                if (['D','N'].includes($(this.docTypeEl).val()) && $el.attr('id').indexOf('supportNumberEsId') != -1) {
                    if (!this.isValidSpanishSupportNumber($el.val())) {
                        $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                        allFilled = false;
                        return;
                    } else {
                        $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                        someFilled += 1;
                    }
                }
                if ($el.attr('id').indexOf('email') != -1) {
                    if (!this.isValidEmail($el.val())) {
                        $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                        allFilled = false;
                        return;
                    } else {
                        $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                        someFilled += 1;
                    }
                }
            }
        });
        this.holder.find('select').each((idx, el) => {
            var $el = $(el);

            if ((!$el.val() || $el.val() == '') && $(this.countryEl).val() == 'ES' && ($el.attr('id').indexOf('province') != -1 || $el.attr('id').indexOf('municipality') != -1)) {
                $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                allFilled = false;
                return;
            } else {
                $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                someFilled += 1;
            }

            if ((!$el.val() || $el.val() == '') && ($el.attr('required') == true || $el.attr('required') == 'required')) {
                $el.closest('.form-group').addClass('has-error').removeClass('has-success');
                allFilled = false;
            } else {
                $el.closest('.form-group').removeClass('has-error').addClass('has-success');
                someFilled += 1;
            }
        });
        if (allFilled) {
            this.holder.addClass('completed');
            this.holder.parent().parent().addClass('complete');
            this.holder.parent().parent().removeClass('incomplete');
            this.holder.closest('.visitor-card').find('.visitor-complete').removeClass('hidden');
            if (window.visitorsInformation) {
                window.visitorsInformation.checkOneFilled();
            }
        } else {
            if (someFilled && !allFilled) {
                this.holder.parent().parent().addClass('incomplete');
            } else {
                this.holder.parent().parent().removeClass('incomplete');
            }
            this.holder.parent().parent().removeClass('complete');
            this.holder.closest('.visitor-card').find('.visitor-complete').addClass('hidden');
            if (window.visitorsInformation) {
                   window.visitorsInformation.checkOneFilled();
            }
        }

    }

    setupEvents() {
        $(`${this.relationshipEl}, ${this.genderEl}`).on('change', (e) => {
            this.checkFilled();
        });

        $(this.nationalityEl).on('change', (e) => {
            var nationality = $(e.target).val();
            if (nationality == 'ES') {
                $(this.surname2El).parent().removeClass('hidden');
                this.spanishDocuments();
                this.updateDocNumberMaxLength(11);
            } else {
                $(this.surname2El).parent().addClass('hidden');
                this.nonSpanishDocuments();
                this.updateDocNumberMaxLength(14);
            }
            this.checkFilled();
        });
        if ($(this.nationalityEl).val() == 'ES') {
            $(this.surname2El).parent().removeClass('hidden');
            this.spanishDocuments();
        } else {
            $(this.surname2El).parent().addClass('hidden');
            this.nonSpanishDocuments();
        }

        $(this.countryEl).on('change', (e) => {
            var country = $(e.target).val();
            if (country == 'ES') {
                $(this.municipalityEl).parent().parent().parent().removeClass('hide');
                $(this.provinceEl).parent().parent().parent().removeClass('hide');
                $(this.cityEl).parent().parent().parent().addClass('hide');
                $(this.cityEl).val('');
            } else {
                $(this.municipalityEl).parent().parent().parent().addClass('hide');
                $(this.provinceEl).parent().parent().parent().addClass('hide');
                $(this.cityEl).parent().parent().parent().removeClass('hide');
                $(this.provinceEl).val('');
                $(this.municipalityEl).val('');
            }
            this.checkFilled();
        });

        $(this.municipalityEl).on('change', (e) => {
            this.checkFilled();
        });
        $(this.provinceEl).on('change', (e) => {
            this.checkFilled();
        });

        $(this.countryEl).trigger('change');

        if ($(this.surnameEl).val() != '' || $(this.firstnameEl).val()) {
            this.setTitle();
        }

        $(this.docTypeEl).on('change', (e) => {
            var docType = $(e.target).val();
            if (docType == 'D' || docType == 'N') {
                $(this.supportNumberEsIdEl).parent().parent().parent().removeClass('hidden');
            } else {
                $(this.supportNumberEsIdEl).parent().parent().parent().addClass('hidden');
            }
            this.checkFilled();
        });
        var docType = $(e.target).val();
        if (docType == 'D' || docType == 'N' || docType == '' || docType == null) {
            $(this.supportNumberEsIdEl).parent().parent().parent().removeClass('hidden');
        } else {
            $(this.supportNumberEsIdEl).parent().parent().parent().addClass('hidden');
        }
        $(`${this.birthdateEl}_day, ${this.birthdateEl}_month, ${this.birthdateEl}_year`).on('change', (e) => {
            const day = $(this.birthdateEl + '_day').val();
            const month = $(this.birthdateEl + '_month').val();
            const year = $(this.birthdateEl + '_year').val();
        
            const allFilled = day > 0 && month > 0 && year > 0;
        
            const $formGroup = $(this.birthdateEl + '_day').closest('.form-group');
            if (allFilled) {
                $formGroup.removeClass('has-error').addClass('has-success');
        
                const birthdate = `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
                this.age = moment().diff(moment(birthdate, 'DD-MM-YYYY'), 'years');
        
                const $relationshipWrapper = $(this.relationshipEl).closest('.form-group');
                if (this.age < 18) {
                    $relationshipWrapper.removeClass('hide');
                    if (this.age < 14) {
                        if ($(this.nationalityEl).val() === 'ES') {
                            if ($(this.docTypeEl).val() === 'D') {
                            $(this.docNumEl).val('0000000A');
                            }
                            if ($(this.docTypeEl).val() === 'P') {
                                $(this.docNumEl).val('AAA000000');
                            }
                        } else {
                            if ($(this.docTypeEl).val() === 'P' || $(this.docTypeEl).val() === 'O') {
                                $(this.docNumEl).val('000000000A');
                            }
                        }
                        // set docDate to yesterday
                        const yesterday = moment().subtract(1, 'days').format('DD-MM-YYYY');
                        const [day, month, year] = yesterday.split('-');
                        $(this.docDateEl + '_day').val(day);
                        $(this.docDateEl + '_month').val(month);
                        $(this.docDateEl + '_year').val(year);
                    }
                } else {
                    $relationshipWrapper.addClass('hide');
                }
            } else {
                $formGroup.addClass('has-error').removeClass('has-success');
            }
            this.checkFilled();
        });
        const $day = $(this.birthdateEl + '_day');
        const $month = $(this.birthdateEl + '_month');
        const $year = $(this.birthdateEl + '_year');
        
        const day = $day.val();
        const month = $month.val();
        const year = $year.val();
        
        if (day > 0 && month > 0 && year > 0) {
            const birthdateStr = day.padStart(2, "0") + '-' + month.padStart(2, "0") + '-' + year;
            const birthdate = moment(birthdateStr, 'DD-MM-YYYY', true);
        
            if (birthdate.isValid()) {
                this.age = moment().diff(birthdate, 'years');
        
                const $relationshipGroup = $(this.relationshipEl).closest('.form-group');
                if (this.age < 18) {
                    $relationshipGroup.removeClass('hide');
                } else {
                    $relationshipGroup.addClass('hide');
                }
            } else {
                // Handle invalid date (optional)
                console.warn('Invalid birthdate:', birthdateStr);
            }
        }
        $(this.supportNumberEsIdEl).on('keyup', function(event) {
            var supportNumberEsId = $(this).val();
            $(this).val( supportNumberEsId.toUpperCase() );
        });

        // check doc expedition date to see if it's before today
        $(`${this.docDateEl}_day,  ${this.docDateEl}_month, ${this.docDateEl}_year`).on('change',  (e) => {
            const day = $(`${this.docDateEl}_day`).val();
            const month = $(`${this.docDateEl}_month`).val();
            const year = $(`${this.docDateEl}_year`).val();

            if (day > 0 && month > 0 && year > 0) {
                const docDateStr = day.padStart(2, "0") + '-' + month.padStart(2, "0") + '-' + year;
                const docDate = moment(docDateStr, 'DD-MM-YYYY', true);
                if (docDate.isValid() && docDate.isBefore(this.todayDate)) {
                    $(`${this.docDateEl}_day`).closest('.form-group').removeClass('has-error').addClass('has-success');
                    $(`${this.docDateEl}_day`).closest('.form-group').find('.error-message').addClass('hide');
                } else {
                    $(`${this.docDateEl}_day`).closest('.form-group').addClass('has-error').removeClass('has-success');
                    $(`${this.docDateEl}_day`).closest('.form-group').find('.error-message').removeClass('hide');
                }
                this.checkFilled();
            }
        });
        
        const currentVisitorIndex = this.getCurrentVisitorIndex();
        if (currentVisitorIndex != "0") {
            let copyFromElements = this.holder.find('.copy-from-main');
            copyFromElements.each((index, element) => {
                $(element).on('click', (e) => {
                    let type = e.target.dataset.copyFromType;
                    this.copyFromMain(type); // `this` here still refers to your class if you're using an arrow function
                });
            });
        } else {
            let copyFromElements = this.holder.find('.copy-from-main');
            copyFromElements.each((index, element) => {
                $(element).remove();
            });
        }
    }

    spanishDocuments() {
        var newOptions = {
            'D': CVTranslator.trans('visitorsinfo.dni', {}, 'messages'),
            'P': CVTranslator.trans('visitorsinfo.passport', {}, 'messages')
        };
        var currentType = $(this.docTypeEl).val();
        $(this.docTypeEl).find('option:gt(0)').remove();

        $.each(newOptions, (value,key) => {
            if (value == currentType) {
                $(this.docTypeEl).append('<option value="'+value+'" selected="selected" >'+key+'</option>');
            } else {
                $(this.docTypeEl).append('<option value="'+value+'" >'+key+'</option>');
            }
        });
        if ($(this.surnameEl).val() != '' || $(this.firstnameEl).val()) {
            this.setTitle();
        }
        $(this.docNumEl).on('keyup', function(event) {
            $(this).val( $(this).val().replace(/[^a-zA-Z0-9]/g,'') );
        });
    }

    nonSpanishDocuments() {
        var newOptions = {
            'P' : CVTranslator.trans('visitorsinfo.passport', {}, 'messages'),
            'N' : CVTranslator.trans('visitorsinfo.spanish_residence_permit', {}, 'messages'),
            'O' : CVTranslator.trans('visitorsinfo.other', {}, 'messages')
        };
        var currentType = $(this.docTypeEl).val();
        $(this.docTypeEl).find('option:gt(0)').remove();
        $.each(newOptions, (value,key) => {
            if (value == currentType) {
                $(this.docTypeEl).append('<option value="'+value+'" selected="selected" >'+key+'</option>');
            } else {
                $(this.docTypeEl).append('<option value="'+value+'" >'+key+'</option>');
            }
        });
        $(this.surname2El).val('');
        if ($(this.surnameEl).val() != '' || $(this.firstnameEl).val()) {
            this.setTitle();
        }
        $(this.docNumEl).off("keyup");
    }
    updateDocNumberMaxLength(length) {
        $(this.docNumEl).attr('maxlength', length);
        var docNumber = ($(this.docNumEl).val()) ? $(this.docNumEl).val() : "";
        $(this.docNumEl).val(docNumber.substr(0,length));
    }
    setTitle(title) {
        var firstname = $(this.firstnameEl).val();
        var surname = $(this.surnameEl).val();
        var surname2 = ($(this.surname2El).val() && !$(this.surname2El).parent().hasClass('hidden')) ? ' ' + $(this.surname2El).val() : '';
        if ( firstname != '' || surname != '' || surname2 != '' ) {
            $(this.firstnameEl).closest('.visitor-card').find('.card-title div.visitor-name').text(firstname + ' ' + surname + surname2 );
        } else {
            if (title == '' || title == null) {
                var defaultTitle = $(this.firstnameEl).closest('.visitor-card').find('.card-title div.visitor-name').data('default-title');
                $(this.firstnameEl).closest('.visitor-card').find('.card-title div.visitor-name').text(defaultTitle);
            } else {
                $(this.firstnameEl).closest('.visitor-card').find('.card-title div.visitor-name').text(title);
            }
        }
    }

    verifyDate(value) {
        var m = moment(value, 'DD-MM-YYYY', true);
        return m.isValid();
    }

    isValidSpanishId(value, type) {
        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
        var nieRexp = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
        var str = value.toString().toUpperCase();
        if (type == 'D') {
            if (nifRexp.test(str) ) {
                return true;
            }
        }
        if (type == 'N') {
            if (nieRexp.test(str)) {
                var nie = str
                .replace(/^[X]/, '0')
                .replace(/^[Y]/, '1')
                .replace(/^[Z]/, '2');
            
                var letter = str.substr(-1);
                var charIndex = parseInt(nie.substr(0, 8)) % 23;
            
                if (validChars.charAt(charIndex) === letter) {
                    return true;
                }
            }
        }
        return false;
    }

    isValidSpanishPassport(passportNumber) {
        const passportRegex = /^[A-Z]{3}\d{6}$/i;
        return passportRegex.test(passportNumber);
    }

    isValidSpanishSupportNumber(supportNumber) {
        // Support number format: E12345678, C12345678, ABC123456
        // 
        const supportNumberRegexTIE = /^E\d{8}$/;
        const supportNumberRegexDNI= /^[A-Z]{3}\d{6}$/i;
        const supportNumberRegexNIE = /^C\d{8}$/;
        let paddedSupportNumber = '';

        if($(this.docTypeEl).val() == 'D') {
            return (supportNumberRegexDNI.test(supportNumber.toUpperCase())) ;
        }

        if (supportNumber.charAt(0) == 'E' || supportNumber.charAt(0) == 'C') {
            paddedSupportNumber = this.supportNumberPadding(supportNumber, supportNumber.charAt(0));
            return (supportNumberRegexTIE.test(supportNumber.toUpperCase()) || supportNumberRegexNIE.test(supportNumber.toUpperCase()) );
        } else {
            if ($(this.docTypeEl).val()  == 'N') {
                let paddedSupportNumberNIE = this.supportNumberPadding(supportNumber, 'C');
                let paddedSupportNumberTIE = this.supportNumberPadding(supportNumber, 'E');
                return (supportNumberRegexNIE.test(paddedSupportNumberNIE.toUpperCase()) || supportNumberRegexTIE.test(paddedSupportNumberTIE.toUpperCase()));
            }
        }
        // If the support number does not match any of the formats, return false
        return false;
    }

    supportNumberPadding(supportNumber, prefix ) {
        validPrefixes = ['E', 'C'];
        if (validPrefixes.indexOf(prefix) === -1) {
            return supportNumber;
        }
        const paddedNumber = supportNumber.toString().padStart(8, '0');
        return prefix + paddedNumber;
    }

    clear() {
        if (this.holder.hasClass('completed')) {
            bootbox.confirm(CVTranslator.trans('areyousure.clearselection', {}, 'messages'), function (result) {
                if (result) {
                    $(this.firstnameEl).val(null);
                    $(this.genderEl).val(null);
                    $(this.surnameEl).val(null);
                    $(this.nationalityEl).val(null);
                    $(this.surname2El).val(null);
                    $(this.docTypeEl).val(null);
                    $(this.docNumEl).val(null);
                    $(this.emailEl).val(null);
                    this.setTitle();

                    $(this.birthdateEl + "_day").val(null);
                    $(this.birthdateEl + "_month").val(null);
                    $(this.birthdateEl + "_year").val(null);

                    $(this.docDateEl + "_day").val(null);
                    $(this.docDateEl + "_month").val(null);
                    $(this.docDateEl + "_year").val(null);

                    $(this.phoneNumberEl).val(null);
                    $(this.addressEl).val(null);
                    $(this.address2El).val(null);
                    $(this.cityEl).val(null);
                    $(this.postalCodeEl).val(null);
                    $(this.countryEl).val(null);
                    $(this.relationshipEl).val(null);
                    $(this.supportNumberEsIdEl).val(null);
                    $(this.provinceEl).val(null);
                    $(this.municipalityEl).val(null);
                    
                    this.checkFilled();
                }
            }.bind(this));
        } else {
            $(this.firstnameEl).val(null);
            $(this.genderEl).val(null);
            $(this.surnameEl).val(null);
            $(this.nationalityEl).val(null);
            $(this.surname2El).val(null);
            $(this.docTypeEl).val(null);
            $(this.docNumEl).val(null);
            $(this.emailEl).val(null);
            this.setTitle();

            $(this.birthdateEl + "_day").val(null);
            $(this.birthdateEl + "_month").val(null);
            $(this.birthdateEl + "_year").val(null);

            $(this.docDateEl + "_day").val(null);
            $(this.docDateEl + "_month").val(null);
            $(this.docDateEl + "_year").val(null);

            $(this.phoneNumberEl).val(null);
            $(this.addressEl).val(null);
            $(this.address2El).val(null);
            $(this.cityEl).val(null);
            $(this.postalCodeEl).val(null);
            $(this.countryEl).val(null);
            $(this.relationshipEl).val(null);
            $(this.supportNumberEsIdEl).val(null);
            $(this.provinceEl).val(null);
            $(this.municipalityEl).val(null);
            this.checkFilled();
        }
    }

    copyAddressToAll() {
        bootbox.confirm(CVTranslator.trans('visitorsinfo.areyousure.copy_address_to_all', {}, 'messages'), function (result) {
            if (result) {
                let currentVisitorData = {};
                currentVisitorData['index'] = this.getCurrentVisitorIndex();
                currentVisitorData['address'] = $(this.addressEl).val();
                currentVisitorData['address2'] = $(this.address2El).val();
                currentVisitorData['city'] = $(this.cityEl).val();
                currentVisitorData['postalCode'] = $(this.postalCodeEl).val();
                currentVisitorData['country'] = $(this.countryEl).val();
                currentVisitorData['municipality'] = $(this.municipalityEl).val();
                currentVisitorData['province'] = $(this.provinceEl).val();
                currentVisitorData['phoneNumber'] = $(this.phoneNumberEl).val();

                let elements = document.querySelectorAll('[id^="cvrm_visitors_information_visitorsInformation_"]');
                let visitorIds = [];
                elements.forEach((element) => {
                    let id = element.id;
                    let matches = id.match(/cvrm_visitors_information_visitorsInformation_(\d+)/);
                    if (matches) {
                        if (!visitorIds.includes(matches[1])) {
                            visitorIds.push(matches[1]);
                        }
                    }
                });
                
                // filter matches on address fields
                const copyFields = [
                    'phoneNumber',
                    'country',
                    'address',
                    'address2',
                    'city',
                    'postalCode',
                    'province',
                    'municipality'
                ];
                visitorIds.forEach((visitorId) => {
                    // skip current visitor
                    if (visitorId == currentVisitorData['index']) {
                        return;
                    }
                    // copy data to other visitors
                    copyFields.forEach((field) => {
                        let fieldId = `cvrm_visitors_information_visitorsInformation_${visitorId}_${field}`;
                        let fieldEl = document.getElementById(fieldId);
                        if (fieldEl) {
                            fieldEl.value = currentVisitorData[field];
                        }
                        if (field == 'country' || field == 'province') {
                          //  $(fieldId).trigger('change');
                            const event = new Event("change");
                            fieldEl.dispatchEvent(event);
                        }
                    });
                    const key = `cvrm_visitors_information_visitorsInformation_${visitorId}`;
                    const obj = window[key];
                    if (obj && typeof obj.checkFilled === 'function') {
                        obj.checkFilled();
                    }
                });
                
                bootbox.alert(CVTranslator.trans('address_info_copied', {}, 'messages'));
            }
        }.bind(this));

    }

    getCurrentVisitorIndex() {
        let el = document.querySelector(this.nationalityEl);
        let matches = el.id.match(/cvrm_visitors_information_visitorsInformation_(\d+)/);
        if (matches) {
            return matches[1];
        } else {
            return null;
        }
    }

    copyFromMain(type) {
        if (type === 'email') {
            let src = document.getElementById('cvrm_visitors_information_visitorsInformation_0_email');
            $(this.emailEl).val(src.value);
        }
        if (type === 'phoneNumber') {
            let src = document.getElementById('cvrm_visitors_information_visitorsInformation_0_phoneNumber');
            $(this.phoneNumberEl).val(src.value);
        }
        if (type === 'address') {
            const copyFields = [
                'address',
                'address2',
                'city',
                'postalCode',
                'country',
                'province',
                'municipality'
            ];
            let currentVisitorIndex = this.getCurrentVisitorIndex();
            copyFields.forEach((field) => {
                let fieldSrcId = `cvrm_visitors_information_visitorsInformation_0_${field}`;
                let fieldSrcEl = document.getElementById(fieldSrcId);
            
                if (fieldSrcEl) {
                    let fieldId = `cvrm_visitors_information_visitorsInformation_${currentVisitorIndex}_${field}`;
                    let fieldTargetEl = document.getElementById(fieldId);
            
                    if (fieldTargetEl) {
                        fieldTargetEl.value = fieldSrcEl.value;
            
                        if (field === 'country' || field === 'province') {
                            // Trigger native 'change' event
                            const changeEvent = new Event('change', { bubbles: true });
                            fieldTargetEl.dispatchEvent(changeEvent);
                        }
                    }
                }
            });
        }
        this.checkFilled();
    }

    isValidEmail(email) {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(email);
      }
}

module.exports = VisitorInformation;
